<template>
  <div>
    <!-- 导航栏 - S -->
    <nav class="ct-header navbar navbar-default navbar-fixed-top">  <!--glyphicon glyphicon-menu-hamburger -->
      <div class="header-logo">
        <router-link to="/home">
          <img src="../assets/images/logo_header.png" class="logo-header"/>
        </router-link>
      </div>
      <div class="ct-content">
        <div class="href-ul">
          <ul class="nav nav-pills" style="display: flex;align-items: center;" @mouseleave="leave()">
            <li @mouseenter="mouseenter('aboutCompany')">
              <a class="dropdrow_a">{{$t('NavabarText.navbar_about')}} <i class="icon iconfont iconxiala xiala"></i></a>
              <div class="dropdown" v-if="dropdownIndex=='aboutCompany'">
                <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                  <li @click="liJump('aboutUs')">{{$t('ContractText.aboutzhouxin')}}</li>
                  <li @click="liJump('technology')">{{$t('ContractText.technology')}}</li>
                  <li @click="liJump('accreditation')" style="line-height:20px;!important">{{$t('ContractText.qualification')}}</li>
                  <li @click="liJump('media')">{{$t('ContractText.mediacenter')}}</li>
                  <li @click="liJump('partnership')">{{$t('ContractText.cooperation')}}</li>
                  <li @click="liJump('career')">{{$t('ContractText.recruitment')}}</li>
                </ul>
              </div>
            </li>
            <li @mouseenter="mouseenter('item')" @mouseleave="leaveSecond()">
              <a class="dropdrow_a">{{$t('NavabarText.navbar_item')}} <i class="icon iconfont iconxiala xiala"></i></a>
              <div class="dropdown" v-if="dropdownIndex=='item'||dropdownSecondIndex=='health'||dropdownSecondIndex=='cancer'||dropdownSecondIndex=='diseases'||dropdownSecondIndex=='risk'">
                <ul :class="$store.state.lang!='en-US'?'':'dropdown_second_special_three'">
                  <li @mouseenter="mouseenterSecond('health')" class="second-div">
                    <div class="second-ul" :class="$store.state.lang!='en-US'?'':'second_ul_special'" @click="liJump('reproductinvhealth')">
                      <span>{{$t('ContractText.reproductivehealth')}} </span><i class="icon iconfont iconxiangyou xiangyou"></i>
                    </div>
                    <div class="dropdown-second" :class="$store.state.lang!='en-US'?'':'dropdown_second_special'" v-if="dropdownSecondIndex=='health'">
                      <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                        <li @click="liJump('yChromosomeDNATest')">{{$t('ContractText.Y_chromosome_maternal_blood')}}</li>
                        <li @click="liJump('mthfr')">{{$t('Mthfr.Title')}}</li>
                        <li @click="liJump('nonInvasivePrenatalTest')">{{$t('ContractText.Noninvasiveprenataltesting')}}</li>
                        <li @click="liJump('nonInvasivePrenatalPaternityTest')">{{$t('ContractText.Noninvasive_prenatal_paternity_test')}}</li>
                        <li @click="liJump('paternitytesting')">{{$t('ContractText.Paternity_testing')}}</li>
                        <!-- <li>{{$t('ContractText.Fragile_X_syndrome_screening')}}</li> -->
                        <li @click="liJump('monogenicdisease')">{{$t('ContractText.Detection_of_monogenic_genetic_diseases')}}</li>
                        
                      </ul>
                    </div>
                  </li>
                  <li @mouseenter="mouseenterSecond('cancer')" class="second-div">
                    <div class="second-ul" :class="$store.state.lang!='en-US'?'':'second_ul_special'" @click="liJump('cancerdescript')">
                      <span>{{$t('ContractText.cancer')}}</span><i class="icon iconfont iconxiangyou xiangyou"></i>
                    </div>
                    <div class="dropdown-second" :class="$store.state.lang!='en-US'?'':'dropdown_second_special_two'" v-if="dropdownSecondIndex=='cancer'">
                      <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                        <li @click="liJump('genetictumordetection')">{{$t('ContractText.Genetic_tumor_detection')}}</li>
                        <li @click="liJump('cancerrealtime')">{{$t('ContractText.Cancer_real_time_monitoring')}}</li>
                      </ul>
                    </div>
                  </li>
                  <li @mouseenter="mouseenterSecond('diseases')" class="second-div">
                    <div class="second-ul" :class="$store.state.lang!='en-US'?'':'second_ul_special'" @click="liJump('infectiousdisease')">
                      <span>{{$t('ContractText.Infectious_diseases')}}</span><i class="icon iconfont iconxiangyou xiangyou"></i>
                    </div>
                    <div class="dropdown-second" :class="$store.state.lang!='en-US'?'':'dropdown_second_special_two'" v-if="dropdownSecondIndex=='diseases'">
                      <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                        <li @click="liJump('vaccinetest')">{{$t('ContractText.Vaccine_antibody_test')}}</li>
                        <li @click="liJump('stdfastces')">{{$t('ContractText.STD_quick_test')}}</li>
                      </ul>
                    </div>
                  </li>
                  <li @mouseenter="mouseenterSecond('risk')" class="second-div">
                    <div class="second-ul" :class="$store.state.lang!='en-US'?'':'second_ul_special'" @click="liJump('healthylife')">
                      <span>{{$t('ContractText.Health_and_disease_risk')}}</span>
                      <i class="icon iconfont iconxiangyou xiangyou"></i>
                    </div>
                    <div class="dropdown-second" v-if="dropdownSecondIndex=='risk'">
                      <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                        <li @click="liJump('innategene')">{{$t('ContractText.Talent_gene_testing')}}</li>
                        <!-- <li>{{$t('ContractText.Noninvasive_prenatal_testing')}}</li> -->
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
            <!-- <li>
              <a href="/#/search" @click="handleTabsClick('search')" :class="active=='search'?'active':''">{{$t('NavabarText.navbar_search')}}</a>
            </li> -->
            <li>
              <a href="/#/news" @click="handleTabsClick('news')" :class="active=='news'?'active':''">{{$t('NavabarText.navbar_newinformation')}}</a>
            </li>
            <li>
              <a href="/#/gensuniverse" @click="handleTabsClick('gensuniverse')" :class="active=='gensuniverse'?'active':''">{{$t('NavabarText.navbr_jiyin')}}</a>
            </li>
            <li>
              <a href="/#/contact" @click="handleTabsClick('contact')" :class="active=='contact'?'active':''">{{$t('NavabarText.navbar_contact')}}</a>
            </li>
            <li @mouseenter="mouseenter('Search')" class="search-tip">
              <a class="dropdrow_a search-btn">{{$t('NavabarText.navbar_search')}} <i class="icon iconfont iconsousuo sousuo"></i></a>
              <div class="dropdown" v-if="dropdownIndex=='Search'">
                <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'">
                  <li @click="liJump('Yreport')">{{$t('NavabarText.navbar_searchy')}}</li>
                  <li @click="liJump('MTHFRreport')">{{$t('NavabarText.navbar_searchys')}}</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <!-- <div class="search-tip">
          <a class="search-btn"  @click="handleTabsClick('Yreport')" >
                  {{$t('NavabarText.navbar_search')}} 
              <span class="icon iconfont iconsousuo sousuo"></span>
          </a>
        </div> -->
        <div class="lang-transfer" @click="langChangClick('zh-TCC')">
          <img src="../assets/images/hk.png" class="logo-headers"/>
          <span class="lang">繁</span>
        </div>
        <div class="lang-transfer" @click="langChangClick('zh-CN')">
          <img src="../assets/images/cn.png" class="logo-headers"/>
          <span class="lang">简</span>
        </div>
        <div class="lang-transfer" @click="langChangClick('en-US')">
          <img src="../assets/images/en.png" class="logo-headers"/>
          <span class="lang">Eng</span>
        </div>
      </div>
    </nav>
    <!-- 导航栏 - E -->
    <div class="routerview">
      <router-view></router-view>
    </div>
    <div class="foot-content">
      <div class="content-foot">
        <div class="content-item-foot">
          <div class="item-foot special-item-foot">
            <span class="foot-tip">{{$t('ContractText.aboutus')}}</span>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('aboutUs')">{{$t('ContractText.aboutzhouxin')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('technology')">{{$t('ContractText.technology')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('accreditation')">{{$t('ContractText.qualification')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('media')">{{$t('ContractText.mediacenter')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('partnership')">{{$t('ContractText.cooperation')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('career')">{{$t('ContractText.recruitment')}}</div>
          </div>
          <!-- <div class="item-foot">
               <div class="curpoint">{{$t('ContractText.genetic_tumor')}}</div>
          </div> -->
        </div>
        <div class="content-item-foot">
          <div class="item-foot special-item-foot">
            <span class="foot-tip">{{$t('ContractText.TestingService')}}</span>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('yChromosomeDNATest')">{{$t('ContractText.Y_chromosome')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('nonInvasivePrenatalTest')">{{$t('ContractText.PrenatalTesting')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('nonInvasivePrenatalPaternityTest')">{{$t('ContractText.Prenatal_Paternity_Testing')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('paternitytesting')">{{$t('ContractText.Paternity_testing')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('monogenicdisease')">{{$t('ContractText.Detection_diseases')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('genetictumordetection')">{{$t('ContractText.genetic_tumor')}}</div>
          </div>

          <div class="item-foot">
            <div class="curpoint" @click="liJump('cancerrealtime')">{{$t('ContractText.CancerReal')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('vaccinetest')">{{$t('ContractText.Vaccine')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('stdfastces')">{{$t('ContractText.STD_quick_test')}}</div>
          </div>
          <div class="item-foot">
            <div class="curpoint" @click="liJump('innategene')">{{$t('ContractText.genetesting')}}</div>
          </div>
        </div>
        <div class="content-item-foot">
          <div class="item-foot special-item-foot" @click="liJump('news')">
            <span class="foot-tip">{{$t('ContractText.newinfo')}}</span>
          </div>
          <div class="item-foot special-item-foot" @click="liJump('gensuniverse')">
            <span class="foot-tip">{{$t('ContractText.GeneUniverse')}}</span>
          </div>
          <div class="item-foot special-item-foot" @click="liJump('contact')">
            <span class="foot-tip">{{$t('ContractText.ContactUs')}}</span>
          </div>
          <div class="item-foot" @mouseleave="leave()">
            <button class="search-btn" @mouseenter="mouseenter('Searchsd')">
              {{$t('NavabarText.navbar_search')}}
              <span class="icon iconfont iconsousuo sousuo"></span>
            </button>
             <div  class="dropdown_bottom" v-if="dropdownIndex=='Searchsd'">
                <ul :class="$store.state.lang!='en-US'?'':'second_ul_special'" >
                  <li @click="liJump('Yreport')">{{$t('ContractText.Yreport')}}</li>
                  <li @click="liJump('MTHFRreport')">{{$t('ContractText.MTHFRreport')}}</li>
                </ul>
              </div>
          </div>
             
          <div class="item-foot special-item-foot">
            <div class="foot-tip" style="width:150px;"><img src="../assets/images/wechatone.jpg" class="logo-weixin"/></div>

          </div>
          <div class="item-foot special-item-foot"><span class="foot-tip">掃碼關注公眾號</span></div>
        </div>

        <div class="content-item-foot">
          <div class="item-foot special-item-foot">
            <span class="foot-tip">{{$t('ContractText.CompanyName')}}</span>
          </div>
          <div class="item-foot">
            <div class="icon iconfont iconshouye icon-span"></div>
            <div class="icon-content address-icon-content">{{$t('ContractText.addressfoot')}}</div>
          </div>
          <div class="item-foot">
            <span class="icon iconfont icondianhua icon-span"></span>
            <span class="icon-content">(+852) 2865 9399</span>
          </div>
          <div class="item-foot">
            <span class="icon iconfont iconjibenxinxi icon-span"></span>
            <span class="icon-content">(+852) 2865 9600</span>
          </div>
          <div class="item-foot">
            <span class="icon iconfont iconyoujian icon-span"></span>
            <span class="icon-content">info@hkfirstchoice.com</span>
          </div>

          <div class="content-item-foot margin-t">
            <div class="item-foot special-item-foot">
              <span class="foot-tip">{{$t('ContractText.servicetime')}}</span>
            </div>
            <div class="item-foot item-special-item ">
              <div class="weeks" style="width: 140px; text-align: left;">{{$t('ContractText.weeks')}}</div>
              <div class="weeks-content">
                <div>10:00 – 18:00</div>
                <!-- <div>14:30 – 18:00</div> -->
              </div>
            </div>
            <div class="item-foot item-special-item ">
              <div class="weeks" style="width: 140px; text-align: left;">{{$t('ContractText.saturday')}}</div>
              <div class="weeks-content" v-if="$store.state.lang!='en-US'">
                <div>10:00 – 13:00</div>
              </div>
              <div class="weeks-content" v-if="$store.state.lang='en-US'">
                <div>10:00 – 13:00</div>
              </div>
            </div>
            <!-- <div class="item-foot">
                  <div>{{$t('ContractText.holidays')}}</div>
            </div> -->
          </div>

        </div>
      </div>
    </div>
    <div class="foot-bottom-content">
      <!-- <div class="foot-bottom-content-item" style="text-align:right;width:25% !important">

      </div> -->
      <div class="foot-bottom-content-item" style="width:90% !important">
        <div><img src="../assets/images/carir.png" style="width:160px;height:auto;margin-right:60px;"/></div>
        <div class="right_content_foot">
          <div>{{$t('ContractText.verson')}} © 2017-2024 {{$t('ContractText.company_full_name')}}</div>
          <div><span class="cursor"><a @click="liJumps('terms')" class="cursor">{{$t('ContractText.termsofuse')}} </a> </span>| <span class="cursor"><a @click="liJumps('privacy')" class="cursor">{{$t('ContractText.privacypolicy')}}</a></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script type="text/javascript">
  export default {
    data() {
      return {
        langText: this.$store.state.lang == 'en-US' ? 'English | 繁' : '繁 | English',
        active: 'home',
        dropdownIndex: '',
        dropdownSecondIndex: '',
      }
    },
    watch: {
      '$route'() {
        console.log('ssdd', this.$route);
        var routeName = this.$route.name;
        if (routeName == 'cancerdescript' || routeName == 'reproductinvhealth' || routeName == 'infectiousdisease' || routeName == 'healthylife') {
          console.log($(window).scrollTop());
          if ($(window).scrollTop() > 900) {
            $('.navbar-default').addClass('Opactiy');//opactiy=1
            $('.routerview').removeClass('routerviewPadding');
            $('.gens-universe').removeClass('gens_universes');
            $('.gens-universe_cancers').removeClass('gens_universes');
          } else {
            var box_twos = document.querySelector(".Opactiy");
            if (box_twos != null) {
              $('.navbar-default').removeClass('Opactiy');//Opacity=0.5
              $('.gens-universe').removeClass('gens_universes');
              $('.gens-universe_cancers').removeClass('gens_universes');
            }
            $('.navbar-default').addClass('Opactiyszerofive')
            var box_three = document.querySelector(".routerviewPadding");
            if (box_three != null) {
              $('.routerview').removeClass('routerviewPadding');
            }

          }
        } else {
          $('.navbar-default').removeClass('Opactiy');
          $('.navbar-default').removeClass('Opactiyszerofive')
          document.querySelector(".navbar-default").classList.remove('Opactiy');
          document.querySelector(".navbar-default").classList.remove('Opactiyszerofive');
          $('.routerview').addClass('routerviewPadding');
          $('.gens-universe').addClass('gens_universes');
          $('.gens-universe_cancers').addClass('gens_universes');
        }

      }
    },
    mounted() {
      var routeName = this.$route.name;
      if (routeName == 'cancerdescript' || routeName == 'reproductinvhealth' || routeName == 'infectiousdisease' || routeName == 'healthylife') {
        console.log($(window).scrollTop());
        if ($(window).scrollTop() > 900) {
          $('.navbar-default').addClass('Opactiy');//opactiy=1
          $('.routerview').removeClass('routerviewPadding');
          $('.gens-universe').removeClass('gens_universes');
          $('.gens-universe_cancers').removeClass('gens_universes');
        } else {
          $('.navbar-default').addClass('Opactiyszerofive')

          var box_twos = document.querySelector(".Opactiy");
          if (box_twos != null) {
            $('.navbar-default').removeClass('Opactiy');//Opacity=0.5
            $('.gens-universe').removeClass('gens_universes');
            $('.gens-universe_cancers').removeClass('gens_universes');
          }
          var box_three = document.querySelector(".routerviewPadding");
          if (box_three != null) {
            $('.routerview').removeClass('routerviewPadding');
          }

        }
      } else {
        $('.navbar-default').removeClass('Opactiy');
        $('.navbar-default').removeClass('Opactiyszerofive')
        $('.routerview').addClass('routerviewPadding');
        $('.gens-universe').addClass('gens_universes');
        $('.gens-universe_cancers').addClass('gens_universes');
      }
      if (this.isMobileDevice()) {//是手机 跳转到手机地址

        window.location.href = "https://m.hkfirstchoice.com";
      }

      $(window).scroll(function () { //滚动某位置 动画特效

        var box_two = document.querySelector(".routerview .gens-universe");
        var box_three = document.querySelector(".routerview .gens-universe_cancers");
        var box_four = document.querySelector(".routerview .gens-infectiousdisease");
        var box_five = document.querySelector(".routerview .gens-healthylife");
        if (box_two != null || box_three != null || box_four != null || box_five != null) {
          if ($(window).scrollTop() > 900) {
            $('.navbar-default').addClass('Opactiy');
            $('.navbar-default').removeClass('Opactiyszerofive')
          } else {
            var box_twos = document.querySelector(".Opactiy");
            if (box_twos != null) {
              $('.navbar-default').removeClass('Opactiy');

            }
            $('.navbar-default').addClass('Opactiyszerofive')
          }
        } else {
          $('.navbar-default').addClass('Opactiy');
        }

      })
    },
    methods: {
      isMobileDevice() {
        let isMobile = false;
        let thisOS = navigator.platform,
          userAgent = navigator.userAgent,
          appVersion = navigator.appVersion;
        let os = ["iPhone", "iPod", "iPad", "android", "Nokia", "SymbianOS", "Symbian", "Windows Phone", "Phone", "Linux armv71", "MAUI", "UNTRUSTED/1.0", "Windows CE", "BlackBerry", "IEMobile"];
        for (let i = 0; i < os.length; i++)
          if (thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
            isMobile = true;

        //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
        if (navigator.platform.indexOf('iPad') != -1)
          isMobile = true;

        //做这一部分是因为Android手机的内核也是Linux
        //但是navigator.platform显示信息不尽相同情况繁多,因此从浏览器下手，即用navigator.appVersion信息做判断
        if (appVersion.match(/linux/i))
        //X11是UC浏览器的平台 ，如果有其他特殊浏览器也可以附加上条件
          if (appVersion.match(/mobile/i) || appVersion.match(/X11/i))
            isMobile = true;

        return isMobile;
      },
      langChangClick(lang) {
        // console.log(this.langText, this.$store.state.lang);
        // if (this.$store.state.lang == 'zh-TCC') {
        //   this.langText = 'English | 繁';
        //   console.log(this.langText);
        //   this.$i18n.locale = 'en-US';
        //   this.$store.commit('setlang', 'en-US');
        // } else {
        //   this.langText = '繁 | English';
        //   this.$store.commit('setlang', 'zh-TCC');
        //   this.$i18n.locale = 'zh-TCC';
        //   console.log(this.langText);
        // }
        this.$store.commit('setlang', lang);
        this.$i18n.locale = lang;
      },

      handleTabsClick(name) {
        this.active = name;
        this.$router.push({
          path: name
        });
      },
      mouseenter(value) {
        this.dropdownIndex = value
      },
      leave() {
        this.dropdownIndex = ''
      },
      mouseenterSecond(value) {
        this.dropdownSecondIndex = value
      },
      leaveSecond() {
        this.dropdownSecondIndex = ''
        this.dropdownIndex = ''
      },
      liJump(path) {
        this.$router.push({
          path: path
        })
      }, liJumps(path) {
        this.$router.push({
          path: path
        })
      },
    },
  }

</script>

<style lang="scss" scoped>
  @import '../assets/font/iconfont.css';

  .ct-header {
    padding: 5px 0;
    width: 100%;
    min-width: 1260px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    z-index: 999999;
    margin-bottom: 0;
  }

  .logo-weixin {
    height: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .header-logo {

  }

  .ct-content {
    font-family: 'Microsoft JhengHei', sans-serif !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .search-tip {
    margin-left: 10px;
    
    .search-btn {
      height: 5rem;
      background-color: #368da7;
      color: #fff;
      border-radius: 50px;
      padding: 10px 20px;
      border: solid 1px #368da7;
      text-decoration: none;
      cursor: pointer;
      font-size: 18px;
      font-weight: bold;
    }

  }

  .search-tip a:hover {
    background-color: #13abc0 !important;
    color: #fff;
  }

  .href-ul {

  }

  .lang-transfer {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    line-height: 8rem;
    letter-spacing: 0rem;
    color: #368da7;
    cursor: pointer;
    margin-left: 3px;
    margin-left: 1rem;
  }

  .lang-transfer:hover {
    background-color: #13abc0 !important;
    color: #fff !important;
  }

  .navbar-default {
    border-color: #ffffff !important;
  }

  .three-line {
    color: #13abc0;
    font-size: 2.5rem;
  }

  .dropdown-menu {
    min-width: 4rem !important;

  }

  .nav li a {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 8rem;
    padding: 6px 8px 3px 8px !important;
    color: #368da7;
    font-size: 18px;
    font-weight: 600;
    text-transform: none;
  }

  .dropdrow_a {
    position: relative;
  }

  .dropdrow_a:hover {

  }

  .xiala {
    margin-left: 10px;
    font-size: 14px;
  }

  .xiangyou {
    font-size: 12px;
    color: #888;
  }

  .second-ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .dropdown {
    position: absolute;
    padding: 10px 20px;
    background-color: #ebfaff;
    text-align: left;
    min-width: 225px;

    ul {
      list-style: none;
      padding: 7px 0;
      margin: 0;
      line-height: 27px;
      letter-spacing: .07em !important;
      color: #3b3b3b;
      font-weight: 400;
      font-size: 16px;

    }

    li {
      padding: 3px 0;
      cursor: pointer;
      font-weight: bold;
    }

    li:hover {
      color: #13abc0;
    }

  }

  .second-ul {

  }

  .second_ul_special {
    font-size: 15px !important;
  }

  .second-div {
    position: relative;
  }

  .dropdown-second {
    display: block;
    position: absolute;
    padding: 10px 20px;
    background-color: #ebfaff;
    left: 100%;
    margin-left: 20px;
    min-width: 225px;
    top: -18px;
    overflow: visible;

    ul {
      list-style: none;
      padding: 7px 0;
      margin: 0;
      line-height: 27px;
      letter-spacing: 0.07em !important;
      color: #3b3b3b;
      font-weight: 400;
      font-size: 14px;
    }

    li {
      padding: 3px 0;
      cursor: pointer;
      font-weight: bold;
      font-size: 16px;;
    }

    li:hover {
      color: #13abc0;
    }
  }

  .dropdown_second_special {
    min-width: 250px;
    line-height: 29px !important;

    ul {
      li {
        line-height: 20px;
        margin-top: 10px;

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }

  .dropdown_second_special_two {
    min-width: 330px !important;
  }

  .dropdown_second_special_three {
    min-width: 220px !important;
  }


  .nav li a:hover {
    color: #13abc0;
  }

  .nav-pills li a {
    border-radius: 0;
  }

  .nav-pills > li + li {
    margin-left: 0;
  }

  .nav li a {
    color: #368da7;
  }

  .nav li a:hover {
    background: #13abc0;
    color: #fff;
  }

  .active {
    background: #fff !important;
    color: #13abc0 !important;
  }

  .Opactiyszerofive .active {
    background: none !important;
  }

  // .nav li a:link{
  //    background: #368da7;
  //   color:#fff;
  // }
  .dropdown-menu li a {
    font-size: 1.2rem;
    letter-spacing: 0rem;
    color: #13abc0;
    font-weight: bold !important;
  }

  .dropdown-menu li a:active {

    color: #13abc0 !important;
  }

  .logo-header {

    height: 100%;
    // margin-left: 2.3rem;
    width: 55%;
  }

  .logo-headers {
    cursor: pointer;
  }

  .lang {

  }

  .lang:hover {
    // color: #fff !important;
  }

  .routerview {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-height: 600px;
    overflow-y: auto;
    left: 0;
    right: 0;

  }

  .foot-content {
    width: 100%;
    background: #368da7;
    color: #fff;
    padding-top: 30px;
    padding-bottom: 30px;

    .content-foot {
      display: flex;
      justify-content: space-between;
      justify-items: center;
      width: 1200px;
      margin: auto;

      .content-item-foot {
        display: flex;
        justify-content: left;
        flex-direction: column;

        .item-foot {
          max-width: 400px;
          display: flex;
          justify-content: left;
          align-items: flex-start;

          margin-top: 4px;
          margin-bottom: 4px;

          &:first-child {
            margin-top: 0;
          }

          .foot-logo {
            height: 100%;
          }

          .foot-wechat {
            height: 120px;
          }

          .icon-span {
            font-size: 16px;
            color: #fff;
          }

          .icon-content {
            margin-left: 12px;
            font-size: 14px;
            color: #fff;
            text-align: left;
          }

          .address-icon-content {

          }

          .weeks-content {
            margin-left: 0px;
            display: flex;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column;
          }

          .curpoint {
            cursor: pointer;
            font-size: 14px;
          }

          .search-btn {
            // margin-top:20px;
            // padding:5px 15px;
            // color:#ffffff;
            // border:solid 2px #ffffff;
            // font-size: 14px;
            // border-radius: 35%;
            // background-color: rgb(54, 141, 167);
            background-color: #ffffff !important;
            color: #368da7 !important;
            font-size: 18px;
            font-weight: bold;
            border-radius: 30px;
            padding: 10px 15px;
            border: solid 2px #ffffff;
          }

          .sousuo {
            margin-left: 5px;
          }
        }


        .item-special-item {
          margin-top: 10px;
          align-items: flex-start;
          justify-content: flex-start;

        }

        .special-item-foot {
          position: relative;
          color: #9bd9dd;
          margin-bottom: 8px;
        }

        // .special-item-foot:after{
        //   content:" ";
        //   position:absolute;
        //   left:0;
        //   width:10%;
        //   height:4px;
        //   transform:scaleY(.5);
        //   margin-top:20px;
        //   background-color:#9bd9dd;
        // }
        .foot-tip {
          font-weight: 600;
          font-size: 18px;
          cursor: pointer;
        }

      }

      .margin-t {
        margin-top: 10px;
      }

    }
  }


  .foot-bottom-content {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    padding: 0 15%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    .foot-bottom-content-item {
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #368da7;
      padding-left: 10%;
      //width:33.33%;
      .right_content_foot {
        display: flex;
        flex-direction: column;
        margin-left: 100px;
      }

      a {
        color: #368da7;
      }
    }

    .cursor {
      cursor: pointer;
    }

    .cursor:hover {
      color: #9bd9dd;
    }
  }

  .Opactiy {
    background: #fff !important;
  }

  .Opactiyszerofive {
    background: rgba(0, 0, 0, 0) !important;

    ul {
      li {
        color: #fff !important;
      }
    }

    a {
      color: #fff !important;
    }

    .lang {
      color: #fff;
    }

    .dropdown {
      ul {

        li {
          color: #000 !important;

        }
      }

      .xiangyou {
        color: #000 !important;
      }
    }
  }

  .routerviewPadding {
    padding: 9rem 0 0 0 !important;
  }

  .gens_universes {
    margin: 1rem 0 0 0 !important;
  }


  .dropdown_bottom {
    position: absolute;
    padding: 10px 20px;
    background-color: #ebfaff;
    text-align: left;
    min-width: 225px;
    z-index: 99999;   
    margin-top: 50px;
    ul {
      list-style: none;
      padding: 7px 0;
      margin: 0;
      line-height: 27px;
      letter-spacing: .07em !important;
      color: #3b3b3b;
      font-weight: 400;
      font-size: 16px;

    }

    li {
      padding: 3px 0;
      cursor: pointer;
      font-weight: bold;
    }

    li:hover {
      color: #13abc0;
    }

  }

</style>

<style>
  .navbar {
    border: 0px solid #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue